import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

// ✅ create a styled wrapper for all buttons in app
const StyledButton = styled(Button)(() => ({
  padding: "10px 16px",
  borderRadius: "8px",
  textTransform: "capitalize",
  fontSize: "14px",
  fontWeight: 500,
  boxShadow: "none",
  backgroundColor: "#46A8DC",
  color: "#fff",
  // "&:hover": {
  //   backgroundColor: "#003CC5",
  // },
  "&.Mui-disabled": {
    backgroundColor: "#9CA3AF",
    color: "#fff",
  },
}));

// ✅ reusable MButton component
const MButton = ({ children, onClick, variant = "contained", ...props }) => {
  return (
    <StyledButton 
    variant={variant} onClick={onClick} {...props}>
      {children}
    </StyledButton>
  );
};

export default React.memo(MButton);
